export default __webpack_public_path__ + "static/media/website-under-construction.409cab66.jpg";